import { TAB_STATUSES } from "@/constants";
import { useUrlParams } from "@/hooks/useUrlParams";
import { isPublicPage } from "@/utils/visualBuilder";

export function useTabStatus() {
  const { tabStatus } = useUrlParams();

  const hasTabStatus = tabStatus !== undefined;

  const isTabCollect = tabStatus === TAB_STATUSES.COLLECT;
  const isTabCustomize = tabStatus === TAB_STATUSES.CUSTOMIZE;
  const isTabPresent = tabStatus === TAB_STATUSES.HOMEBASE;
  const isTabShare = tabStatus === TAB_STATUSES.SHARE;
  const isTabPublic = tabStatus === TAB_STATUSES.PUBLIC;
  const isTabPublicMediaShare = tabStatus === TAB_STATUSES.PUBLIC_MEDIA_SHARE;
  const isTabPublicSingleShare = tabStatus === TAB_STATUSES.PUBLIC_SINGLE_SHARE;

  const isPublicPageTab = isPublicPage(tabStatus ?? "");

  const isPropertyBasedTab = isTabPresent || isTabCollect || isTabPublicMediaShare;

  return {
    hasTabStatus,
    isTabCollect,
    isTabCustomize,
    isTabPresent,
    isTabShare,
    isTabPublic,
    isTabPublicMediaShare,
    isTabPublicSingleShare,
    isPublicPageTab,
    isPropertyBasedTab,
  };
}
